// Glossary tooltip — wraps a term with a dotted underline + native hover/focus
// definition. Use for ICIP, IDS, FPIC, UNDRIP, Lore, Girribal, Q-Level etc.
export default function Term({ children, def, className = "" }) {
  return (
    <abbr
      title={def}
      className={`no-underline border-b border-dotted border-stone-400 cursor-help hover:border-[#9C4221] hover:text-[#9C4221] transition-colors ${className}`}
      data-testid={`term-${typeof children === "string" ? children.toLowerCase().replace(/[^a-z0-9]+/g, "-") : "term"}`}
    >
      {children}
    </abbr>
  );
}

// Pre-defined common terms used across the site
export const TERMS = {
  ICIP: "Indigenous Cultural and Intellectual Property — the stories, language, songs, designs and knowledge that belong to a community.",
  IDS: "Indigenous Data Sovereignty — the principle that Indigenous communities have the right to govern data about their people, country and culture.",
  FPIC: "Free, Prior and Informed Consent — communities must be asked first, given enough information, and able to say no (or change their mind later).",
  UNDRIP: "United Nations Declaration on the Rights of Indigenous Peoples — the international standard for Indigenous rights.",
  Lore: "Aboriginal customary law and cultural authority — the rules and obligations that have governed Country, kinship and knowledge for tens of thousands of years.",
  Girribal: "Girribal — the learning passage; the staged way knowledge is taught and carried.",
  QLevel: "Quill-level escalation — the protected escalation ladder used when authority, consent or cultural protection is unresolved. Q2 is moderate, Q3 is urgent.",
  LoreGate: "Lore-Gate — the permissions checkpoint where a request must pass cultural authority, consent and protocol before access is granted.",
  LoreLed: "Lore-Led — software whose decisions answer to Lore (Aboriginal authority), not the other way around.",
  GovernanceArchaeology: "Governance Archaeology™ — the research method Bigibila offers Nations to trace, remember and reconstruct their own systems of governance through story, kinship, Lore, Country, family line, ceremony and lived responsibility.",
};
